module.exports = __webpack_public_path__ + "img/send_btn.e0491abd.svg";